import selectColorTypeBusiness from "@/components/common/selectColorTypeBusiness";
import { SITE_DOMAIN } from "@/constant";

export const BusinessInitalData = {
  payload: {
    about_us: "",
    description: "",
    svgColor: "",
    website: "",
    app_name: "",
    developer: "",
    logo: "",
    name: "",
    hours_type: "am/pm",
    design_colors_primary: selectColorTypeBusiness[0].color,
    design_colors_button: selectColorTypeBusiness[0].buttonColor,
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    welcome_screen: "",
    welcome_path: "",
    company: "",
    headline: "",
    summary: "",
    button: "",
    button_url: "",
    street_number: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    venue_amenities: [],
    about: "",
    contact_name: "",
    phone: "",
    email: "",
    website_url: "",
    longitude: -73.9855426,
    latitude: 40.7579747,
    address: "",
    street: "",
    socialItems: [],
    showButton: false,
    showMoreAddress: false,
    opening_hours: [
      {
        day: "Monday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Tuesday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Wednesday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Thursday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Friday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Saturday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Sunday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
    ],
    showMoreContact: false,
    showUploadOwn: false,
    showUploadOwnLogo: false,
  },
};

export const AddButtonInitialData = [
  {
    value: "Buy now",
    icon: "",
  },
  {
    value: "Learn more",
    icon: "",
  },
  {
    value: "Shop online",
    icon: "",
  },
  {
    value: "View all items",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];
